import * as React from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";

import Documentos from "../../dominio/documentos/componentes/Documentos";
import RecepcionDocumental from "../../dominio/documentos/componentes/recepcion/RecepcionDocumental";
import DocumentosComercial from "../../dominio/documentos/componentes/DocumentosComercial";
import BandejaTareas from "../../dominio/bandeja/componentes/BandejaTareas";
import Reportes from "../../dominio/reportes/componentes/Reportes";
import InconsistenciaSarlaftComponent from "../../dominio/sarlaft/insconsistencias/componentes/InconsisenciasPrincipal";
import VisorDocumento from "../../dominio/documentos/componentes/VisorDocumento";
import Historicos from "../../dominio/reportes/componentes/Historicos";
import BandejaGlosas from "../../dominio/sat/inconsistencias/componentes/BandejaGlosas";
import EstructuraEmpresas from "../../dominio/sat/estructura_empresas/componentes/EstructuraEmpresas";
import EstructuraAfiliacion from "../../dominio/sat/procesar_empresas/componentes/EstructuraAfiliacion";
import EstructuraRetiroDefinitivo from "../../dominio/sat/procesar_retiro/componentes/EstructuraRetiroDefinitivo";
import EstructuraReporteMora from "../../dominio/sat/procesar_mora/componentes/EstructuraReporteMora";
import AdministradorGlosas from "../../dominio/sat/config_glosas/componentes/AdministradorGlosas";
import AdministradorParametros from "../../dominio/sat/config_parametros/componentes/AdministradorParametros";
import AdministradorServicios from "../../dominio/sat/config_servicios/componentes/AdministradorServicios";
import CargarParametros from '../../dominio/parametros/cargar_parametros/componentes/Cargar';
import ConsultarParametros from "../../dominio/parametros/consultar_parametros/componentes/Consultar";
import FiltrosReporteHistorico from "../../dominio/sat/reporte_historico_rta/componentes/FiltrosReporteHistorico";
import EmpresasTrasladadas from "../../dominio/sat/empresas_trasladadas/componentes/EmpresasTrasladadas";
import FiltroReporteGlosas from "../../dominio/sat/reporte_glosas/componentes/FiltroReporteGlosas";
import FiltroConsultaEmpresasTraslado from "../../dominio/sat/gestion_empresas_trasladables/componentes/FiltroConsultaEmpresasTraslado";
import FiltrosConsultaHistoricos from "../../dominio/sat/consulta_tabla_historicos/componentes/FiltrosConsultaHistoricos";
import EstructuraEnvioMasivoGlosas from "../../dominio/sat/procesar_masivo_glosas/componentes/EstructuraEnvioMasivoGlosas";
import ConsultaNovedadesRecibidas from "../../dominio/sat/recibo_novedades_masivo/componente/ConsultaNovedadesRecibidas";
import FiltroConsultaResumen from "../../dominio/sat/recibo_novedades_resumen/componentes/FiltroConsultaResumen";
import FiltroConsultaDetalle from "../../dominio/sat/recibo_novedades_detalle/componentes/FiltroConsultaDetalle";
import PeriodosMora from "../../dominio/sat/periodos_mora/componentes/PeriodosMora";
import InicioFinRelacionLaboral from "../../dominio/sat/inicio_fin_relacion_laboral/componentes/InicioFinRelacionLaboral";
import FiltroConsultaEnvioMora from "../../dominio/sat/consulta_envio_mora/componentes/FiltroConsultaEnvioMora";

class Router extends React.Component<any, any> {

    render() {
        return (
            <Switch>
                <Route path="/cargarParams" component={CargarParametros} />
                <Route path="/consultarParams" component={ConsultarParametros} />
                <Route path="/verificacion" component={Documentos} />
                <Route path="/recibir_documentos" component={RecepcionDocumental} />
                <Route path="/comerciales" component={DocumentosComercial} />
                <Route path="/bandejaTareas" component={BandejaTareas} />
                <Route path="/reportes" component={Reportes} />
                <Route path="/historicos" component={Historicos} />
                <Route path="/inconsistenciasSAT" component={BandejaGlosas} />
                <Route path="/consultarEmpresasSAT" component={EmpresasTrasladadas} />
                <Route path="/estructuraEmpresasSAT" component={EstructuraEmpresas} />
                <Route path="/procesarEmpresasSAT" component={EstructuraAfiliacion} />
                <Route path="/procesarRetiroSAT" component={EstructuraRetiroDefinitivo} />
                <Route path="/procesarMoraSAT" component={EstructuraReporteMora} />
                <Route path="/administrarGlosasSAT" component={AdministradorGlosas} />
                <Route path="/administrarParametrosSAT" component={AdministradorParametros} />
                <Route path="/administrarServiciosSAT" component={AdministradorServicios} />
                <Route path="/consultarPeriodosMoraSAT" component={PeriodosMora} />
                <Route path="/consultarHistoricoRespuestaSAT" component={FiltrosReporteHistorico} />
                <Route path="/inconsistenciasSarlaft" component={InconsistenciaSarlaftComponent}/>
                <Route path="/consultarReporteGlosas" component={FiltroReporteGlosas} />
                <Route path="/gestionEmpresaTraslado" component={FiltroConsultaEmpresasTraslado} />
                <Route path="/consultaTablaHistorico" component={FiltrosConsultaHistoricos} />
                <Route path="/envioMasivoGlosas" component={EstructuraEnvioMasivoGlosas} />
                <Route path="/consultaNovedadesRecibidasFTP" component={ConsultaNovedadesRecibidas} />
                <Route path="/consultaNovedadesRecibidasResumen" component={FiltroConsultaResumen} />
                <Route path="/consultaNovedadesRecibidasDetalle" component={FiltroConsultaDetalle} />
                <Route path="/consultaInicioFinRelacionLaboral" component={InicioFinRelacionLaboral} />
                <Route path="/consultaEnvioManualMora" component={FiltroConsultaEnvioMora} />
                <Route path="/ver_documento/:idDocumento/:titulo/:dni/:tipoCliente" component={VisorDocumento} />
                <Route path="/" render={() => <h2>Bienvenido</h2>} />
                <Route render={() => (<div className={"page-header"}>
                    404
                </div>)} />
            </Switch>
        );
    }
}

export default withRouter(connect((store: any) => {
    return {
        routes: store.router
    };
})(Router));




// WEBPACK FOOTER //
// ./src/co/sura/inicio/componentes/Router.tsx